<div class="top-nav-root bg-gray-50">
  <div class="header-container">
    <header class="header">
      <div class="header__container">
        <!-- Logo -->
        <div class="logo-container">
          <a routerLink="/">
            <img src="/images/snelwoningruil-logo.png" alt="Snelwoningruil" class="logo-container__image" />
          </a>
        </div>

        @if (!isRootRoute()) {
          <div class="mobile-back-button-container">
            <app-back-button [isMobileScreen]="true"></app-back-button>
          </div>
        }

        <!-- Desktop Search -->
        <div class="search-container">
          <app-property-search (toggleFilters)="toggleFilters()" (searchApplied)="navigateToRoot()"> </app-property-search>
          <app-property-filters [(visible)]="displayFilters" (filtersApplied)="navigateToRoot()"></app-property-filters>
        </div>

        <!-- Desktop Buttons -->
        <div class="button-group">
          <div title="Get More Credit" [routerLink]="['/payment']" class="credit-overview-container">
            <app-credit-overview></app-credit-overview>
          </div>

          <app-chat-icon></app-chat-icon>

          <div class="user-dropdown">
            <button #userAvatar class="avatar-icon" (click)="userMenuElm.toggle($event)">
              <img src="/images/icons/user.svg" alt="User icon" class="avatar-icon-img" />
            </button>

            <sxw-menu #userMenuElm [items]="userMenuItems" [popup]="true"></sxw-menu>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
